module.exports = __webpack_public_path__ + "img/uniones-nipples (1).1c422aad.jpg";